import { call, put } from 'redux-saga/effects'

import { fetchApi } from '../helpers/fetchApi'

import { fetchResourceSuccess, fetchResourceFailure } from '../../actionCreators/resource/resourceActionCreators'

const buildSuccessPayload = jsonData => [jsonData.data].concat(jsonData.included)

const endpoint = '/product-api/pdp-service/partNumber'
const headers = { Accept: `application/vnd.argos-product.v2+json` }

function* resourceSaga(action) {
  const partNumber = action.payload
  try {
    const url = `${endpoint}/${partNumber}`
    const jsonData = yield call(fetchApi, url, '', headers)
    const payload = buildSuccessPayload(jsonData)
    const successAction = fetchResourceSuccess({ partNumber, data: payload, meta: jsonData?.meta })
    yield put(successAction)
  } catch (error) {
    const response = {
      errorDetail: error.toString(),
      errorCode: error.status
    }
    if (error.response && error.response.body && error.response.body.errors) {
      response.errorDetail = error.response.body.errors
    }
    const failureAction = fetchResourceFailure({ partNumber, ...response })
    yield put(failureAction)
  }
}

export { resourceSaga, endpoint }
